import { ComponentsProps, ComponentsOverrides, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/material';

export const ChipTheme = (): {
  defaultProps?: ComponentsProps['MuiChip'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiChip'];
  variants?: ComponentsVariants['MuiChip'];
} => {
  return {
    styleOverrides: {
      root: () => ({
        textTransform: 'capitalize',
        borderRadius: '8px'
      }),
      outlined: ({ theme, ownerState }) => {
        const bgColor: Record<string, string> = {
          warning: theme.palette.warning.light,
          error: theme.palette.error.light,
          success: theme.palette.success.light
        };

        const backgroundColor = bgColor[ownerState.color as keyof typeof bgColor] || theme.palette.error.light;

        return {
          backgroundColor
        };
      }
    }
  };
};
